export default __webpack_public_path__ + "static/media/playstore.ef6a09d0.svg";